import apiService from "./apiService";
import AppConstants from "../appConstants";

class VectorizationManagementService {
    getAll(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_VECTORIZATION_MANAGEMENT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_VECTORIZATION_MANAGEMENT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    register(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_VECTORIZATION_MANAGEMENT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    delete(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_VECTORIZATION_MANAGEMENT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_VECTORIZATION_MANAGEMENT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new VectorizationManagementService();
